export default __webpack_public_path__ + "static/media/KAIROSALPHA.2a34690a.jpg";